import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import Swal from 'sweetalert2';
var AddEditDigiManagerComponent = /** @class */ (function () {
    function AddEditDigiManagerComponent(fb, transformerMangService, digiDashbioard, dialogRef, gididata) {
        var _this = this;
        this.fb = fb;
        this.transformerMangService = transformerMangService;
        this.digiDashbioard = digiDashbioard;
        this.dialogRef = dialogRef;
        this.gididata = gididata;
        this.fuelTypes = ['Diesel', 'Petrol', 'Gas', 'Other'];
        this.phaseTypes = ['Single Phase', 'Three Phase'];
        this.statuses = ['Active', 'Inactive', 'Under Maintenance'];
        this.defaultParams = [
            'PF', 'KWH', 'RPM', 'KVAH',
            'KVARH', 'Gen_Hz', 'Oil_Temp', 'Total_KW',
            'Total_KVA', 'Fuel_Level', 'L1_Current', 'L1_Voltage',
            'L2_Current', 'L2_Voltage', 'L3_Current', 'L3_Voltage',
            'Total_KVAR', 'L1L2_Voltage', 'L2L3_Voltage', 'L3L1_Voltage'
        ];
        // ✅ Generator Form
        this.generatorForm = this.fb.group({
            generatorId: ['', Validators.required],
            installationDate: ['', Validators.required],
            capacity: ['', Validators.required],
            fuelType: ['', Validators.required],
            manufacturerName: ['', Validators.required],
            modelNumber: ['', Validators.required],
            ratedVoltage: ['', Validators.required],
            ratedCurrent: ['', Validators.required],
            ratedFrequency: ['', Validators.required],
            phaseType: ['', Validators.required],
            fuelTankCapacity: ['', Validators.required],
            status: ['', Validators.required],
            lastServiceDate: [''],
            city: ['', Validators.required],
            deviceId: ['', Validators.required],
            fuelPrice: ['', Validators.required]
        });
        // ✅ Parameters Form
        this.parameterForm = this.fb.group({
            parameters: this.fb.array([])
        });
        // initialize with default parameters
        this.defaultParams.forEach(function (p) {
            _this.parameters.push(_this.fb.group({
                name: [p, Validators.required],
                enabled: [true]
            }));
        });
        // ✅ Alert Parameters Form
        this.alertParameterForm = this.fb.group({
            alertParameters: this.fb.array([])
        });
        // Preload default parameters
        this.loadDefaultParams();
        // ✅ Alert Notifications Form
        this.alertNotificationForm = this.fb.group({
            emails: this.fb.array([
                this.fb.group({
                    email: ['', [Validators.required, Validators.email]]
                })
            ])
        });
    }
    AddEditDigiManagerComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.gididata.action == "edit") {
            var discription = JSON.parse(this.gididata.data.description);
            var alertParamsFromServer = JSON.parse(this.gididata.data.alertParameter);
            var ParamsFromServer = JSON.parse(this.gididata.data.parameters);
            var notificationFromServer = JSON.parse(this.gididata.data.alertNotification);
            this.generatorForm.patchValue(discription);
            var alertParametersFA_1 = this.alertParameterForm.get('alertParameters');
            alertParametersFA_1.clear();
            alertParamsFromServer.alertParameters.forEach(function (param) {
                alertParametersFA_1.push(_this.createeditParameter(param));
            });
            var ParametersFA_1 = this.parameterForm.get('parameters');
            ParametersFA_1.clear();
            ParamsFromServer.parameters.forEach(function (param) {
                ParametersFA_1.push(_this.fb.group({
                    name: [param.name, Validators.required],
                    enabled: [param.enabled]
                }));
            });
            var notificationFA_1 = this.alertNotificationForm.get('emails');
            notificationFA_1.clear();
            notificationFromServer.alertNotifications.forEach(function (param) {
                notificationFA_1.push(_this.fb.group({
                    email: [param.email, [Validators.required, Validators.email]]
                }));
            });
        }
        this.getDeviceDdl();
        this.getParameters();
    };
    AddEditDigiManagerComponent.prototype.getDeviceDdl = function () {
        var _this = this;
        this.transformerMangService.getDeviceDdl().toPromise().then(function (response) {
            _this.deviceMaster = response.data.deviceId;
        });
    };
    AddEditDigiManagerComponent.prototype.getParameters = function () {
        this.digiDashbioard.getDigiParameters().toPromise().then(function (response) {
            console.log(response);
        });
    };
    Object.defineProperty(AddEditDigiManagerComponent.prototype, "parameters", {
        // -------- Parameters --------
        get: function () {
            return this.parameterForm.get('parameters');
        },
        enumerable: true,
        configurable: true
    });
    AddEditDigiManagerComponent.prototype.addParameter = function () {
        this.parameters.push(this.fb.group({
            name: ['', Validators.required],
            enabled: [true]
        }));
    };
    AddEditDigiManagerComponent.prototype.removeParameter = function (index) {
        this.parameters.removeAt(index);
    };
    Object.defineProperty(AddEditDigiManagerComponent.prototype, "alertParameters", {
        // -------- Alert Parameters --------
        get: function () {
            return this.alertParameterForm.get('alertParameters');
        },
        enumerable: true,
        configurable: true
    });
    AddEditDigiManagerComponent.prototype.createParameter = function (name) {
        return this.fb.group({
            name: [{ value: name, disabled: true }, Validators.required],
            threshold: ['', Validators.required],
            emailToggle: [false]
        });
    };
    AddEditDigiManagerComponent.prototype.createeditParameter = function (data) {
        return this.fb.group({
            name: [{ value: data.name, disabled: true }, Validators.required],
            threshold: [data.threshold, Validators.required],
            emailToggle: [data.emailToggle]
        });
    };
    AddEditDigiManagerComponent.prototype.loadDefaultParams = function () {
        var _this = this;
        this.defaultParams.forEach(function (param) {
            _this.alertParameters.push(_this.createParameter(param));
        });
    };
    AddEditDigiManagerComponent.prototype.addalertParameter = function (name) {
        if (name === void 0) { name = ''; }
        this.alertParameters.push(this.fb.group({
            name: [name, Validators.required],
            threshold: ['', Validators.required],
            emailToggle: [false]
        }));
    };
    AddEditDigiManagerComponent.prototype.removealertParameter = function (index) {
        this.alertParameters.removeAt(index);
    };
    Object.defineProperty(AddEditDigiManagerComponent.prototype, "emailControls", {
        // -------- Alert Notifications --------
        get: function () {
            return this.alertNotificationForm.get('emails');
        },
        enumerable: true,
        configurable: true
    });
    AddEditDigiManagerComponent.prototype.addEmail = function () {
        if (this.emailControls.length < 5) {
            this.emailControls.push(this.fb.group({
                email: ['', [Validators.required, Validators.email]]
            }));
        }
    };
    AddEditDigiManagerComponent.prototype.removeEmail = function (index) {
        this.emailControls.removeAt(index);
    };
    // -------- Save Validation --------
    AddEditDigiManagerComponent.prototype.isAllFormsValid = function () {
        return this.generatorForm.valid &&
            this.parameterForm.valid &&
            this.alertParameterForm.valid &&
            this.alertNotificationForm.valid;
    };
    AddEditDigiManagerComponent.prototype.saveData = function () {
        var _this = this;
        if (!this.isAllFormsValid())
            return;
        var data = tslib_1.__assign({ description: this.generatorForm.value }, this.parameterForm.getRawValue(), this.alertParameterForm.getRawValue(), this.alertNotificationForm.value);
        console.log('Saving Data:', data);
        // Call API here
        if (this.gididata.action != "edit") {
            this.digiDashbioard.addGenerator(data).subscribe(function (resp) {
                if (resp.status) {
                    Swal.fire({
                        title: 'Success!',
                        text: 'Digi Manager saved successfully.',
                        icon: 'success',
                        confirmButtonColor: '#4CAF50',
                    });
                    _this.dialogRef.close(true);
                }
            });
        }
        else {
            this.digiDashbioard.UpdateGenerator(data).subscribe(function (resp) {
                if (resp.status) {
                    Swal.fire({
                        title: 'Success!',
                        text: 'Digi Manager saved successfully.',
                        icon: 'success',
                        confirmButtonColor: '#4CAF50',
                    });
                    _this.dialogRef.close(true);
                }
            });
        }
    };
    return AddEditDigiManagerComponent;
}());
export { AddEditDigiManagerComponent };
